
<template>
  <slot/>
</template>